import { c as _c } from "react/compiler-runtime";
import { isDefined } from '@morpho-org/morpho-ts';
import { useCallback, useEffect, useState } from 'react';
export function useStickyMaxInput(t0) {
  const $ = _c(11);
  const {
    maxValue,
    onChange
  } = t0;
  const [isMaxActive, setIsMaxActive] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = value => {
      setIsMaxActive(value);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const onMaxClick = t1;
  let t2;
  let t3;
  if ($[1] !== isMaxActive || $[2] !== maxValue || $[3] !== onChange) {
    t2 = () => {
      if (isMaxActive && isDefined(maxValue)) {
        onChange(maxValue);
      }
    };
    t3 = [isMaxActive, maxValue, onChange];
    $[1] = isMaxActive;
    $[2] = maxValue;
    $[3] = onChange;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== onChange) {
    t4 = value_0 => {
      setIsMaxActive(false);
      onChange(value_0);
    };
    $[6] = onChange;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const onManualChange = t4;
  let t5;
  if ($[8] !== isMaxActive || $[9] !== onManualChange) {
    t5 = {
      isMaxActive,
      onMaxClick,
      onManualChange
    };
    $[8] = isMaxActive;
    $[9] = onManualChange;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}